import {Component, Input, OnInit} from '@angular/core';
import {HttpResponse, HttpErrorResponse, HttpEventType, HttpEvent} from '@angular/common/http';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {Observable} from 'rxjs';
import {FileObject, IFileObject} from '../../shared/model/file-object.model';
import {FileObjectService} from './file-object.service';
// import {MeetingService} from '../meeting/meeting.service';
// import {IMeeting} from '../../shared/model/meeting.model';
import {NgbActiveModal, NgbModal, NgbPanelChangeEvent, NgbRatingConfig} from '@ng-bootstrap/ng-bootstrap';
import {NgxSpinnerService} from 'ngx-spinner';
import {AccountService} from '../../singelton/account.service';
import {ToastrService} from 'ngx-toastr';
import {FileUploadService} from './file-upload-service';
import {JhiDataUtils} from 'ng-jhipster';
import {Customer} from "../../shared/model/customer.model";
import {contains} from "html2canvas/dist/types/core/bitwise";
import {ISupplier, Supplier} from "../../shared/model/supplier.model";
import {SupplierService} from "../supplier/supplier.service";
import {Organization} from "../../shared/model/organization.model";
import {Phone} from "../../shared/model/phone.model";
import {Employee, IEmployee} from "../../shared/model/employee.model";
import {IRapidCustomer} from "../../shared/model/rapid-customer.model";
import {Factor, IFactor} from "../../shared/model/factor.model";
import {FactorService} from "../factor/factor.service";
import {EventService} from "../../singelton/event.service";
import {EmployeeService} from "../../core/employee/employee.service";
import {IIncoming} from "../../shared/model/incoming.model";
import * as moment from "jalali-moment";
import {IKala} from "../../shared/model/kala.model";
import {KalaService} from "../kala/kala.service";

@Component({
  selector: 'app-file-object-prj-update',
  templateUrl: './file-object-prj-update.component.html',
  styles: [`
    .star {
      font-size: 1.5rem;
      color: #b0c4de;
    }

    .filled {
      color: #1e90ff;
    }

    .bad {
      color: #deb0b0;
    }

    .filled.bad {
      color: #ff1e1e;
    }

    .star .fas {
      font-size: 17px !important;
    }
  `]

})

export class FileObjectPrjUpdateComponent implements OnInit {
  // @Input() doctor_id;
  @Input() file_id;
  @Input() factorEdit;
  @Input() title;
  @Input() action;
  @Input() customerId;
  @Input() supplierId;
  @Input() projectId;
  @Input() factorId;
  @Input() contractId;
  @Input() orderId;
  @Input() orderBuyId;
  @Input() salesCycleId;
  @Input() employee;
  @Input() client;
  @Input() token;
  @Input() typeFactor;
  dateObject2: any;
  assignDateObject2: any;

  get isAssignSupplier(): boolean {
    return this.action === 'assign_supplier';
  }

  get isPreFactorAdd(): boolean {
    return this.action === 'add' && this.title === 'preFactor';
  }

  /** ثبت فاکتور از تب فاکتورهای پروژه (افزودن یا تبدیل پیش‌فاکتور به فاکتور) */
  get isMainFactorProjectForm(): boolean {
    return this.title === 'mainFactor' && (this.action === 'add' || this.action === 'factor_add');
  }

  /** آپلود فایل‌ها در فرم‌های فاکتور/پیش‌فاکتور پروژه اختیاری است */
  get isProjectFactorFilesOptional(): boolean {
    return this.isPreFactorAdd || this.isMainFactorProjectForm;
  }

  get requireSupplierFields(): boolean {
    if (this.isPreFactorAdd) {
      return false;
    }
    if (this.isAssignSupplier) {
      return true;
    }
    return this.action !== 'add' || this.title === 'mainFactor';
  }

  get requireSalesFile(): boolean {
    return !this.isProjectFactorFilesOptional && !this.isAssignSupplier;
  }

  get requireSupplierFile(): boolean {
    return !this.isProjectFactorFilesOptional && this.requireSupplierFields && !this.isAssignSupplier;
  }

  get isSaveDisabled(): boolean {
    if (this.isSaving) {
      return true;
    }
    if (this.isAssignSupplier) {
      if (this.factorEdit && !this.factorLoaded) {
        return true;
      }
      return !this.isAssignSupplierFormValid();
    }
    if (this.isProjectFactorFilesOptional || this.action === 'edit') {
      return !this.isFactorFormValid();
    }
    return this.editFormFile.invalid;
  }

  private isAssignSupplierFormValid(): boolean {
    const supplierId = this.editFormFile.get('supplier_id').value;
    const amountS = this.editFormFile.get('amount_s').value;
    return !!supplierId && !!amountS && String(amountS).trim().length > 0 && !!this.assignDateObject2;
  }

  private isFactorFormValid(): boolean {
    const title = this.editFormFile.get('title').value;
    const amount = this.editFormFile.get('amount').value;
    if (!title || String(title).trim().length === 0) {
      return false;
    }
    if (!amount || String(amount).trim().length === 0) {
      return false;
    }
    if ((this.action === 'add' || this.action === 'factor_add') && !this.dateObject2) {
      return false;
    }
    return true;
  }

  step = 2;
  type: any;
  phone_id: any;
  kalas: IKala[];
  factor: IFactor = new Factor();
  factorLoaded = true;
  private pendingFactorForEdit: IFactor;
  total_amount_factor_final: any = 0;
  employees: IEmployee[];

  public serverValidationError = false;
  public serverValidationError_msg_title = "";
  public serverValidationError_msg = "";

  isSaving: boolean;
  errorImport: boolean = false;
  fileObjects: IFileObject[] = [];
  showAddParam: boolean;
  editFormFile = this.fb.group({
    id: [],
    title: [],
    title_s: [],
    supplier: [],
    supplier_id: [],
    description: [],
    amount: [],
    amount_s: [],
    type: [],
    itemName: [],
    size: [],
    content: [],
    content_s: [],
    isImgProfile: [],
    imgProfile: [],
    status: [],
    // doctor: [],
    // patient: [],
    // meeting: [],
    uploaded_by: [],
    contentType: [],
    contentType_s: []
  });
  param1: any;
  file: IFileObject = new FileObject();
  uploaded: any;
  file_fileType: any;
  file_fileType_s: any;
  file_size: any;
  file_size_s: any;
  file_itemName: any;
  file_itemName_s: any;
  error: any;
  success: any;
  links: any;
  totalItems: any;
  itemsPerPage: any;
  page: any = 0;
  predicate: any;
  previousPage: any;
  reverse: any;
  sortList: any;
  // meetings: IMeeting[] = [];
  readonly = true;
  selected = 0;
  hovered = 0;

  // doctor: IDoctor = new Doctor();
  // meeting: IMeeting;
  profileImg: IFileObject;
  file_doctor: IFileObject;
  form: FormGroup;
  progress = 0;
  suppliers: ISupplier[];

  beforeChange($event: NgbPanelChangeEvent) {
    if ($event.panelId === 'preventchange-2') {
      $event.preventDefault();
    }

    if ($event.panelId === 'preventchange-3' && $event.nextState === false) {
      $event.preventDefault();
    }
  }

  constructor(protected dataUtils: JhiDataUtils,
              private formBuilder: FormBuilder,
              private activeModal: NgbActiveModal,
              protected fileObjectService: FileObjectService,
              protected activatedRoute: ActivatedRoute,
              protected factorService: FactorService,
              private supplierService: SupplierService,
              private kalaService: KalaService,
              private modalService: NgbModal,
              private fb: FormBuilder,
              public employeeService: EmployeeService,
              private toastr: ToastrService
    , private spinner: NgxSpinnerService,
              protected eventService: EventService,
              public accountService: AccountService
    ,
              config: NgbRatingConfig,
              public fileUploadService: FileUploadService) {
    this.form = this.fb.group({
      name: [''],
      avatar: [null]
    });
    // customize default values of ratings used by this component tree
    // config.max = 5;
    // config.readonly = true;
  }

  ngOnInit() {
    this.isSaving = false;
    this.loadAllSuppliers();

    if (this.isAssignSupplier) {
      this.assignDateObject2 = moment().locale('fa');
      this.editFormFile.get('supplier_id').setValidators([Validators.required]);
      this.editFormFile.get('amount_s').setValidators([Validators.required]);
      this.editFormFile.get('supplier_id').updateValueAndValidity();
      this.editFormFile.get('amount_s').updateValueAndValidity();
    } else if (this.isProjectFactorFilesOptional || this.action === 'edit') {
      this.editFormFile.get('title').setValidators([Validators.required]);
      this.editFormFile.get('amount').setValidators([Validators.required]);
      this.editFormFile.get('title').updateValueAndValidity();
      this.editFormFile.get('amount').updateValueAndValidity();
    }

    this.activatedRoute.params.subscribe((params) => {
      this.type = params['type'];
    });
    this.loadAllEmployee();


    if (this.factorEdit) {
      this.factorLoaded = false;
      this.factorService.find(this.factorEdit).subscribe(
        (res: HttpResponse<IFactor>) => {
          this.factor = res.body;
          this.pendingFactorForEdit = this.factor;
          this.factorLoaded = true;
          this.patchFactorFormFromFactor(this.factor);
          this.setFactorDateFromFactor(this.factor);
          if (this.isAssignSupplier) {
            if (this.factor.supplier_assign_date) {
              const jalaliAssign = moment(this.factor.supplier_assign_date).locale('fa').format('jYYYY/jM/jD HH:mm:ss');
              this.assignDateObject2 = moment(jalaliAssign, 'jYYYY,jMM,jDD  HH:mm:ss');
            } else {
              this.assignDateObject2 = moment().locale('fa');
            }
          }

          // if (this.factor.date) {
          //   const jalaliDate5 = moment(this.factor.date).locale('fa').format('jYYYY/jM/jD HH:mm:ss');
          //
          //   this.dateObject2 = moment(jalaliDate5, 'jYYYY,jMM,jDD  HH:mm:ss');
          // }
          // this.factor.employee_str = this.factor.employee.id;

          // this.numberWithCommasNumber();
        },
        (res: HttpErrorResponse) => {
          this.factorLoaded = true;
          this.onError(res.message);
        }
      );
    }
    this.loadAllKalas();
  }
  loadAllKalas() {

    this.spinner.show();
    this.kalaService.query(
      {
        page: 0,
        size: 100,
        sort: ['id', 'desc'],
      }
    ).subscribe(
      (res: HttpResponse<IKala[]>) => {
        this.kalas = res.body;
        this.spinner.hide();
        if (this.pendingFactorForEdit) {
          this.patchFactorFormFromFactor(this.pendingFactorForEdit);
        }
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }

  loadAllEmployee() {
    this.employeeService.query().subscribe(
      (res: HttpResponse<IEmployee[]>) => {
        this.employees = res.body;
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }


  uploadFile(event) {
    const file = (event.target as HTMLInputElement).files[0];
    this.form.patchValue({
      avatar: file
    });
    this.form.get('avatar').updateValueAndValidity();
  }

  submitUser() {
    this.isSaving = true;

    const fileObject = this.createFormFile();
    if (fileObject.id !== undefined && fileObject.id !== null) {
      this.subscribeToSaveResponseFile(this.fileObjectService.updateProfile(fileObject));
    } else {
      this.subscribeToSaveResponseFile(this.fileObjectService.createProfileImg(fileObject));
    }

  }


  myFunction(id) {
    const x = document.getElementById(id);

    if (x.style.display === 'none') {
      x.style.display = 'block';
    } else {
      x.style.display = 'none';
    }
  }


  showAdd() {
    this.showAddParam = true;
    this.createFormFile();
  }


  open(id) {

    this.fileObjectService.find(id).subscribe((res: HttpResponse<IFileObject>) => {
        this.file = res.body;
        const tabWindowId = window.open('about:blank', '_blank');
        tabWindowId.location.href = this.file.amazonLink;
      },
      (res: HttpErrorResponse) => console.log('______ error ______')
    );
  }

  updateFormFile(fileObject: IFileObject) {
    this.patchFactorFormFromFactor(fileObject as IFactor);
  }

  private patchFactorFormFromFactor(factor: IFactor): void {
    if (!factor) {
      return;
    }
    const supplierId = factor.supplier && factor.supplier.id != null ? factor.supplier.id : null;
    this.editFormFile.patchValue({
      id: factor.id,
      supplier_id: supplierId,
      amount: this.formatAmountForForm(this.resolveSalesAmount(factor)),
      amount_s: this.formatAmountForForm(this.resolveSupplierAmount(factor)),
      title: factor.itemName || factor.title
    });
  }

  private resolveSalesAmount(factor: IFactor): any {
    if (factor.factor_amount_total_number != null) {
      return factor.factor_amount_total_number;
    }
    if (this.isValidAmountValue(factor.pre_factor_amount)) {
      return factor.pre_factor_amount;
    }
    if (factor.factor_amount_number != null) {
      return factor.factor_amount_number;
    }
    return factor.factor_amount;
  }

  private resolveSupplierAmount(factor: IFactor): any {
    if (factor.factor_supplier_amount_total_number != null) {
      return factor.factor_supplier_amount_total_number;
    }
    if (this.isValidAmountValue(factor.pre_factor_supplier_amount)) {
      return factor.pre_factor_supplier_amount;
    }
    return this.isValidAmountValue(factor.factor_supplier_amount) ? factor.factor_supplier_amount : null;
  }

  private isValidAmountValue(value: any): boolean {
    if (value === null || value === undefined) {
      return false;
    }
    const str = String(value).trim();
    return str !== '' && str !== 'null' && str !== 'undefined';
  }

  private formatAmountForForm(value: any): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }
    const strVal = String(value).trim();
    if (strVal === 'null' || strVal === 'undefined') {
      return '';
    }
    if (typeof value === 'number') {
      return this.numberWithCommas(value);
    }
    const normalized = this.disNumberWithCommas(value);
    return normalized ? this.numberWithCommas(normalized) : String(value);
  }

  private setFactorDateFromFactor(factor: IFactor): void {
    const dateVal = factor.factor_type === 'mainFactor' ? factor.factor_date : factor.pre_factor_date;
    if (!dateVal) {
      return;
    }
    let m;
    if (Array.isArray(dateVal)) {
      m = moment(`${dateVal[0]}-${dateVal[1]}-${dateVal[2]}`);
    } else {
      m = moment(dateVal);
    }
    if (m.isValid()) {
      const jalaliDate5 = m.locale('fa').format('jYYYY/jM/jD HH:mm:ss');
      this.dateObject2 = moment(jalaliDate5, 'jYYYY,jMM,jDD  HH:mm:ss');
    }
  }

  byteSize(field) {
    // return this.dataUtils.byteSize(field);
  }

  openFile(contentType, field) {
    // return this.dataUtils.openFile(contentType, field);
  }

  setFileData(event, field: string, isImage) {
    this.serverValidationError = false;
    const name = <HTMLInputElement>document.getElementById('file_content');


    this.file_itemName = name.files.item(0).name;
    this.file_size = name.files.item(0).size + '';
    this.file_fileType = name.files.item(0).type;

    return new Promise((resolve, reject) => {
      if (event && event.target && event.target.files && event.target.files[0]) {
        const file: File = event.target.files[0];
        if (isImage && !file.type.startsWith('image/')) {
          reject(`File was expected to be an image but was found to be ${file.type}`);
        } else {
          const filedContentType: string = field + 'ContentType';
          this.dataUtils.toBase64(file, base64Data => {
            this.editFormFile.patchValue({
              [field]: base64Data,
              [filedContentType]: file.type
            });
          });
        }
      } else {
        reject(`Base64 data was not set as file could not be extracted from passed parameter: ${event}`);
      }
    }).then(
      // eslint-disable-next-line no-console
      () => console.log('blob added'), // success
      this.onError
    );


    // this.dataUtils.setFileData(event, entity, field, isImage);
  }

  setFileData_s(event, field: string, isImage) {
    this.serverValidationError = false;
    const name = <HTMLInputElement>document.getElementById('file_content_s');


    this.file_itemName_s = name.files.item(0).name;
    this.file_size_s = name.files.item(0).size + '';
    this.file_fileType_s = name.files.item(0).type;

    return new Promise((resolve, reject) => {
      if (event && event.target && event.target.files && event.target.files[0]) {
        const file: File = event.target.files[0];
        if (isImage && !file.type.startsWith('image/')) {
          reject(`File was expected to be an image but was found to be ${file.type}`);
        } else {
          const filedContentType: string = field + 'ContentType';
          this.dataUtils.toBase64(file, base64Data => {
            this.editFormFile.patchValue({
              [field]: base64Data,
              [filedContentType]: file.type
            });
          });
        }
      } else {
        reject(`Base64 data was not set as file could not be extracted from passed parameter: ${event}`);
      }
    }).then(
      // eslint-disable-next-line no-console
      () => console.log('blob added'), // success
      this.onError
    );


    // this.dataUtils.setFileData(event, entity, field, isImage);
  }

  previousState() {
    window.history.back();
  }

  hide() {
    this.showAddParam = false;
    this.createFormFile();
  }

  saveFile() {
    this.serverValidationError = false;

    if (this.isAssignSupplier) {
      this.saveAssignSupplier();
      return;
    }

    this.isSaving = true;
    this.progress = this.hasAnyFileToUpload() ? 100 : 0;
    const fileObject = this.createFormFile();

    const span_actionDate2 = document.getElementById('span_actionDate24');
    if (span_actionDate2) {
      fileObject.factor_date_str = (<HTMLInputElement>span_actionDate2).innerHTML;
      fileObject.uploaded = new Date((<HTMLInputElement>span_actionDate2).innerHTML);
      fileObject.date = new Date((<HTMLInputElement>span_actionDate2).innerHTML);
    }
    if (fileObject.amount)
      fileObject.amount = this.disNumberWithCommas(fileObject.amount);

    if (fileObject.amount_s)
      fileObject.amount_s = this.disNumberWithCommas(fileObject.amount_s);


    if (!fileObject.type) {
      fileObject.type = this.typeFactor;
    }
    if (fileObject.supplier_id) {
      fileObject.supplier = new Supplier(fileObject.supplier_id);
    }
    if (this.projectId) {
      fileObject.project = this.projectId;
    }
    // if (this.factor) {
    //   fileObject.factor = this.factor;
    // }
    if (this.contractId) {
      fileObject.contract = this.contractId;
    }
    if (this.orderId) {
      fileObject.order = this.orderId;
      fileObject.customer = this.orderId.customer;
    }
    if (this.orderBuyId) {
      fileObject.orderBuy = this.orderBuyId;
    }
    if (this.salesCycleId) {
      fileObject.salesCycle = this.salesCycleId;
    }
    if (this.customerId || (this.orderId && this.orderId.customer) || this.orderBuyId) {
      if (this.customerId) {
        fileObject.customer = new Customer(this.customerId);
      }
      if ((this.orderId && this.orderId.customer)) {

        fileObject.customer = this.orderId.customer;
      }
      if (this.factor && this.factor.id) {
        fileObject.factor = { id: this.factor.id };
      }
      if (this.action === 'edit') {
        this.subscribeToSaveResponseFile(this.fileObjectService.updateForPrjFactorEdit(fileObject));

      } else if (fileObject.id !== undefined && fileObject.id !== null) {
        this.subscribeToSaveResponseFile(this.fileObjectService.updateForPrjFactor(fileObject));
      } else {
        fileObject.isdeleted = false;

        this.subscribeToSaveResponseFile(this.fileObjectService.createForPrjFactor(fileObject));
      }

    } else {
      this.isSaving = false;
      this.progress = 0;
      this.serverValidationError = true;
      this.serverValidationError_msg_title = 'اطلاعات ناقص است';
      this.serverValidationError_msg = 'مشتری یا پروژه مشخص نشده است.';
    }
  }

  private saveAssignSupplier(): void {
    if (!this.isAssignSupplierFormValid()) {
      this.serverValidationError = true;
      this.serverValidationError_msg_title = 'اطلاعات انتصاب ناقص است';
      this.serverValidationError_msg = 'پیمانکار، مبلغ پیمانکار و تاریخ انتصاب الزامی هستند.';
      return;
    }

    const factorId = this.factorEdit || (this.factor && this.factor.id);
    if (!factorId) {
      this.serverValidationError = true;
      this.serverValidationError_msg_title = 'خطا در انتصاب پیمانکار';
      this.serverValidationError_msg = 'شناسه پیش‌فاکتور یافت نشد.';
      return;
    }

    const assignDateStr = this.getAssignDateStr();
    if (!assignDateStr) {
      this.serverValidationError = true;
      this.serverValidationError_msg_title = 'تاریخ انتصاب نامعتبر است';
      this.serverValidationError_msg = 'لطفاً تاریخ انتصاب را انتخاب کنید.';
      return;
    }

    this.isSaving = true;
    const payload = {
      supplierId: Number(this.editFormFile.get('supplier_id').value),
      supplierAmount: Number(this.disNumberWithCommas(this.editFormFile.get('amount_s').value)),
      assignDateStr
    };

    this.factorService.assignSupplier(factorId, payload).subscribe(
      () => {
        if (this.hasSupplierFileToUpload()) {
          this.uploadSupplierFileAfterAssign(factorId);
        } else {
          this.onSaveSuccessAssignSupplier();
        }
      },
      (res: HttpErrorResponse) => this.onSaveErrorAssignSupplier(res)
    );
  }

  private hasSalesFileToUpload(): boolean {
    const content = this.editFormFile.get('content').value;
    return content != null && String(content).length > 0;
  }

  private hasSupplierFileToUpload(): boolean {
    const contentS = this.editFormFile.get('content_s').value;
    return contentS != null && String(contentS).length > 0;
  }

  private hasAnyFileToUpload(): boolean {
    return this.hasSalesFileToUpload() || this.hasSupplierFileToUpload();
  }

  private uploadSupplierFileAfterAssign(factorId: number): void {
    const fileObject = this.createFormFile();
    fileObject.id = factorId;

    if (!fileObject.type) {
      fileObject.type = this.typeFactor || 'preFactor';
    }
    if (fileObject.amount) {
      fileObject.amount = this.disNumberWithCommas(fileObject.amount);
    }
    if (fileObject.amount_s) {
      fileObject.amount_s = this.disNumberWithCommas(fileObject.amount_s);
    }
    if (fileObject.supplier_id) {
      fileObject.supplier = new Supplier(fileObject.supplier_id);
    }
    if (this.projectId) {
      fileObject.project = this.projectId;
    }
    if (this.customerId) {
      fileObject.customer = new Customer(this.customerId);
    }
    fileObject.factor = { id: factorId };

    this.fileObjectService.updateForPrjFactor(fileObject).subscribe(
      () => this.onSaveSuccessAssignSupplier(),
      (res: HttpErrorResponse) => this.onSaveErrorAssignSupplier(res)
    );
  }

  private getAssignDateStr(): string {
    if (!this.assignDateObject2) {
      return '';
    }
    return moment(this.assignDateObject2).locale('fa').format('jYYYY/jM/jD');
  }

  protected onSaveSuccessAssignSupplier() {
    this.isSaving = false;
    this.progress = 0;
    this.showAddParam = false;
    this.toastr.success('انتصاب پیمانکار با موفقیت انجام شد', '!موفق');
    this.clear();
  }

  protected onSaveErrorAssignSupplier(response: HttpErrorResponse) {
    this.isSaving = false;
    this.progress = 0;
    this.serverValidationError = true;
    if (response.status === 400 && response.error && response.error.message) {
      this.serverValidationError_msg_title = 'خطا در انتصاب پیمانکار';
      this.serverValidationError_msg = response.error.message;
    } else {
      this.serverValidationError_msg_title = 'خطا در انتصاب پیمانکار';
      this.serverValidationError_msg = 'لطفاً دوباره تلاش کنید.';
    }
  }

  approve() {
    this.isSaving = true;

    this.file_doctor.status = 'Approved';
    this.subscribeToSaveResponseFile(this.fileObjectService.update(this.file_doctor));

  }

  private createFormFile(): IFileObject {
    return {
      ...new FileObject(),
      id: this.editFormFile.get(['id']).value,
      description: this.editFormFile.get(['description']).value,
      supplier: this.editFormFile.get(['supplier']).value,
      supplier_id: this.editFormFile.get(['supplier_id']).value,
      type: this.editFormFile.get(['type']).value,
      amount: this.editFormFile.get(['amount']).value,
      amount_s: this.editFormFile.get(['amount_s']).value,
      title: (this.editFormFile.get(['title']).value),
      title_s: (this.editFormFile.get(['title_s']).value),
      uploaded_by: (this.editFormFile.get(['uploaded_by']).value),
      uploaded: this.uploaded,
      date: this.uploaded,
      contentType: this.file_fileType,
      contentType_s: this.file_fileType_s,
      itemName: this.file_itemName,
      itemName_s: this.file_itemName_s,
      size: this.file_size,
      size_s: this.file_size_s,
      // isImgProfile:   false,
      isImgProfile: (this.title === 'profileImg' ? true : false),
      imgProfile: (this.title === 'profileImg' ? true : false),
      // imgProfile: false,
      // doctor: this.doctor,
      status: (this.accountService.hasAnyAuthority(['ROLE_ADMIN']) ? 'Approved' : 'Pending'),
      content: this.editFormFile.get(['content']).value,
      content_s: this.editFormFile.get(['content_s']).value
    };
  }


  protected subscribeToSaveResponseFile(result: Observable<HttpResponse<IFileObject>>) {
    result.subscribe(() => this.onSaveSuccessFile(),
      (res: HttpErrorResponse) => this.onSaveErrorFile(res)
    );

  }

  protected onSaveSuccessFile() {
    this.isSaving = false;
    this.progress = 0;
    this.showAddParam = false;
    this.clear();
    const successMsg = this.isAssignSupplier ? 'انتصاب پیمانکار با موفقیت انجام شد' : 'ثبت فاکتور شما با موفقیت انجام شد';
    this.toastr.success(successMsg, '!موفق');
  }

  clear() {
    this.activeModal.dismiss('save');
  }

  protected onSaveErrorFile(response) {
    this.isSaving = false;
    this.progress = 0;
    if (response.status === 400) {
      this.serverValidationError = true;
      if (response.error.detail.includes('request was larger than')) {
        this.serverValidationError_msg_title = 'حجم فایل نباید بیشتر از 20 مگابایت باشد!';
        this.serverValidationError_msg = 'حجم فایل را چک کنید و دوباره تلاش کنید';
      } else {
        this.serverValidationError_msg_title = 'در بارگذاری فایل خطایی رخ داده است!';
        this.serverValidationError_msg = 'دوباره تلاش کنید';
      }
    } else if (response.status === 500) {
      this.serverValidationError = true;
      this.serverValidationError_msg_title = 'در بارگذاری فایل خطایی رخ داده است!';
      this.serverValidationError_msg = 'خطا در اتصال به شبکه';
    } else {
      this.errorImport = true;
    }
  }

  protected onError(errorMessage: string) {
  }

  loadAllSuppliers() {

    this.spinner.show();
    this.accountService.identity().then(account => {
      this.supplierService.query(
        {
          // page: this.page - 1,
          // size: this.itemsPerPage,
          // sort: this.sort(this.predicate, this.reverse)
        }
      ).subscribe(
        (res: HttpResponse<ISupplier[]>) => {
          this.suppliers = res.body;
          this.spinner.hide();
          if (this.pendingFactorForEdit) {
            this.patchFactorFormFromFactor(this.pendingFactorForEdit);
          }
        },
        (res: HttpErrorResponse) => this.onError(res.message)
      );
    });
  }


  protected subscribeToSaveResponse5(result: Observable<HttpResponse<IRapidCustomer>>) {
    result.subscribe((res: HttpResponse<IRapidCustomer>) => this.onSaveSuccessFactor(res), (res: HttpErrorResponse) => this.onSaveError());
  }

  protected onSaveError() {
  }

  protected onSaveSuccessFactor(res) {
    this.factor = res.body;
    this.isSaving = false;
    this.toastr.success('     ثبت با موفقیت انجام شد.      ', '   کاربر گرامی!    ');
    this.spinner.hide();
    // this.clearForm();
    if (this.factor) {
      this.step = 2;
    }

    this.eventService.onResponseStock('test message 22');


  }


  disNumberWithCommas(x) {
    if (x) {
      x = x.toString().replace(',', '');
      x = x.toString().replace(',', '');
      x = x.toString().replace(',', '');
      x = x.toString().replace(',', '');
      x = x.toString().replace(',', '');
      x = x.toString().replace(',', '');

      return x;
    }
  }


  numberWithCommasNumber() {
    const cost = this.editFormFile.get(['amount']).value;
    const y = this.numberWithCommas(cost);
    this.editFormFile.get(['amount']).setValue(y);
    this.editFormFile.get(['amount']).value(Number(this.numberWithoutCommas(cost)));
  }

  numberWithCommasNumber_s() {
    const cost = this.editFormFile.get(['amount_s']).value;
    const y = this.numberWithCommas(cost);
    this.editFormFile.get(['amount_s']).setValue(y);
    this.editFormFile.get(['amount_s']).value(Number(this.numberWithoutCommas(cost)));
  }

  numberWithCommas(x) {
    if (x === null || x === undefined || x === '') {
      return '';
    }

    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');

    const pattern = /(-?\d+)(\d{3})/;
    while (pattern.test(x)) {
      x = x.replace(pattern, '$1,$2');
    }
    return x;

  }

  numberWithoutCommas(x) {

    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');

    return x;

  }

  numberWithCommas2(y) {
    let x: any = Number(y);
    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');

    const pattern = /(-?\d+)(\d{3})/;
    while (pattern.test(x)) {
      x = x.replace(pattern, '$1,$2');
    }
    return x;

  }

}
